import { gql } from '@apollo/client';
import { TileFieldsFragment } from './fragments';

export const GET_TILES = gql`
  query GetTiles {
    tilesGet {
      tiles {
        ...TileFields
      }
    }
  }
  ${TileFieldsFragment}
`;
